import { VX_IGNORE_SYMBOL } from './parser.js';

export function showPoint(x: number, y: number, clear = true) {
    if (clear) {
        clearOverlay();
    }
    const point = document.createElement('div');
    point.style.position = 'absolute';
    point.style.left = `${x}px`;
    point.style.top = `${y}px`;
    point.style.width = '32px';
    point.style.height = '32px';
    point.style.transform = 'translate(-50%, -50%)';
    point.style.backgroundColor = 'red';
    point.style.borderRadius = '100%';
    point.style.opacity = '0.5';
    const container = getOverlayContainer();
    container.appendChild(point);
}

export function clearOverlay() {
    const container = getOverlayContainer();
    container.remove();
}

export function getOverlayContainer() {
    let container = document.querySelector('#webvision-overlay') as HTMLElement;
    if (!container) {
        container = document.createElement('div');
        (container as any)[VX_IGNORE_SYMBOL] = true;
        container.id = 'webvision-overlay';
        container.style.position = 'fixed';
        container.style.top = '0';
        container.style.left = '0';
        container.style.bottom = '0';
        container.style.right = '0';
        container.style.zIndex = '2147483647'; // Maximum z-index value
        container.style.pointerEvents = 'none';
        document.body.appendChild(container);
    }
    return container;
}
